import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Demo controller left intentionally minimal.
  }
}
